import React from 'react'

import { Box, Display, FlexDirection, Heading4 } from '@gousto-internal/citrus-react'

import { BoxSizePriceBreakdownBlock } from 'routes/Signup/Components/BoxSizePriceBreakdownBlock/BoxSizePriceBreakdownBlock'
import { signupConfig } from 'routes/Signup/signupConfig'

type BoxSizePriceBreakdownProp = { next: () => void }

export const BoxSizePriceBreakdown = ({ next }: BoxSizePriceBreakdownProp) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Column} width="100%" height="100%">
    <Box width="100%">
      <Box paddingBottom={4}>
        <Heading4>{signupConfig.boxSizeStep.title}</Heading4>
      </Box>
      <BoxSizePriceBreakdownBlock next={next} />
    </Box>
  </Box>
)
